import {
  getEventActionName,
  getFailActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import TopLevelMethod from "../../core/TopLevelMethod";
import { combineReducers } from "redux";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { UserData } from "./types";
import ViewerEvent from "../../core/ViewerEvent";

function status(
  state = { statusType: DetailedLoadStatus.WAITING, code: undefined },
  action
) {
  const allFailActions = new RegExp(getFailActionName(".+"));
  if (action.type.match(allFailActions) && action.resultStatus === 401) {
    return { statusType: DetailedLoadStatus.ERROR, code: 401 };
  }

  switch (action.type) {
    case getStartActionName(TopLevelMethod.GET_USER_INFO):
      return { statusType: DetailedLoadStatus.FETCHING, code: undefined };
    case getFailActionName(TopLevelMethod.GET_USER_INFO):
      return {
        statusType: DetailedLoadStatus.ERROR,
        code: action.resultStatus,
      };
    case getSuccessActionName(TopLevelMethod.GET_USER_INFO):
      return { statusType: DetailedLoadStatus.OK, code: action.resultStatus };
    case getEventActionName(ViewerEvent.USER_SIGNOUT):
    case getSuccessActionName(TopLevelMethod.SIGN_OUT):
      return { statusType: DetailedLoadStatus.ERROR, code: 401 };
    case getEventActionName(ViewerEvent.PAGE_ERROR):
      if (action.eventData.code === 401) {
        return { statusType: DetailedLoadStatus.ERROR, code: 401 };
      } else {
        return state;
      }
    default:
      return state;
  }
}

function data(state: any = {}, action) {
  switch (action.type) {
    case getSuccessActionName(TopLevelMethod.SET_USER_INFO):
    case getSuccessActionName(TopLevelMethod.GET_USER_INFO):
      const { preferences, ...rest } = action.resultData;
      return rest;
    case getStartActionName(TopLevelMethod.ENABLE_LAB):
      const enableLabId = action.apiCallArgs[0];
      return {
        ...state,
        labs: {
          ...state.labs,
          [enableLabId]: {
            enabled: true,
          },
        },
      };
    case getStartActionName(TopLevelMethod.DISABLE_LAB):
      const disableLabId = action.apiCallArgs[0];
      return {
        ...state,
        labs: {
          ...state.labs,
          [disableLabId]: {
            enabled: false,
          },
        },
      };
    default:
      return state;
  }
}

export default combineReducers<UserData>({
  status,
  data,
});
